import { render } from "./CloudenteWidget.vue?vue&type=template&id=c708ed0e&scoped=true"
import script from "./CloudenteWidget.vue?vue&type=script&lang=js"
export * from "./CloudenteWidget.vue?vue&type=script&lang=js"

import "./CloudenteWidget.vue?vue&type=style&index=0&id=c708ed0e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c708ed0e"]])

export default __exports__
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinnerGears,QIcon});
